(function() {
  var MERCHANT = 'marc-darcy';
  var API = 'https://api.feefo.com/api/20/reviews';
  var reviewsEl = document.querySelector('[data-pdp-reviews]');
  if (!reviewsEl) return;

  var skuPrefix = reviewsEl.getAttribute('data-product-sku-prefix');
  var sku = skuPrefix + '*';
  var loaded = false;
  var _escEl = document.createElement('div');
  var _starUid = 0;

  // Defer summary fetch until browser is idle
  if ('requestIdleCallback' in window) {
    requestIdleCallback(fetchSummary);
  } else {
    setTimeout(fetchSummary, 2000);
  }

  // Fetch full reviews on first accordion open
  var trigger = document.querySelector('.reviews-tab__trigger');
  if (trigger) {
    trigger.addEventListener('click', function() {
      if (!loaded) {
        loaded = true;
        loadReviews();
      }
    });
  }

  function fetchSummary() {
    fetch(API + '/summary/product?merchant_identifier=' + MERCHANT + '&product_sku=' + encodeURIComponent(sku))
      .then(function(r) { return r.json(); })
      .then(updateHeader)
      .catch(function() {});
  }

  function updateHeader(data) {
    var rating = 0;
    var count = 0;

    if (data.rating) {
      rating = data.rating.rating || 0;
      if (data.rating.product) {
        count = data.rating.product.count || 0;
      }
    }
    if (!count && data.meta) {
      count = data.meta.count || 0;
    }

    if (count > 0) {
      var starsEl = document.querySelector('.reviews-tab__star-icons');
      if (starsEl) {
        starsEl.innerHTML = buildStars(rating);
      }

      var countEl = document.querySelector('.reviews-tab__count');
      if (countEl) {
        countEl.textContent = 'Based on ' + count + ' Review' + (count !== 1 ? 's' : '');
      }
    }
  }

  function loadReviews() {
    reviewsEl.innerHTML = '<div class="pdp-v2-reviews__loading">Loading reviews\u2026</div>';

    fetch(API + '/product?merchant_identifier=' + MERCHANT + '&product_sku=' + encodeURIComponent(sku) + '&page_size=5')
      .then(function(r) { return r.json(); })
      .then(function(data) { renderReviews(data.reviews || [], data.summary ? data.summary.meta : null); })
      .catch(function() {
        reviewsEl.innerHTML = '<p class="pdp-v2-reviews__empty">Unable to load reviews.</p>';
      });
  }

  function renderReviews(reviews, meta) {
    if (!reviews.length) {
      reviewsEl.innerHTML = '<p class="pdp-v2-reviews__empty">No reviews yet for this product.</p>';
      return;
    }

    // Deduplicate reviews (same text + author = same review across variant SKUs)
    var seen = {};
    reviews = reviews.filter(function(review) {
      var product = review.products && review.products[0];
      if (!product) return false;
      var text = product.review || '';
      var author = (review.customer && review.customer.display_name) || 'Verified Customer';
      var key = text + '|' + author;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    }).slice(0, 5);

    var html = '';
    reviews.forEach(function(review) {
      var product = review.products && review.products[0];
      if (!product) return;

      var r = product.rating ? product.rating.rating : 0;
      var text = product.review || '';
      var author = (review.customer && review.customer.display_name) || 'Verified Customer';
      var date = formatDate(review.last_updated_date || product.created_at);

      html += '<div class="pdp-v2-reviews__card">';
      html += '<div class="pdp-v2-reviews__card-header">';
      html += '<div class="pdp-v2-reviews__card-stars">' + buildStars(r) + '</div>';
      html += '<span class="pdp-v2-reviews__card-date">' + esc(date) + '</span>';
      html += '</div>';
      if (text) {
        html += '<p class="pdp-v2-reviews__card-text">' + esc(text) + '</p>';
      }
      html += '<span class="pdp-v2-reviews__card-author">' + esc(author) + '</span>';
      html += '</div>';
    });

    var totalCount = meta ? meta.count : reviews.length;
    if (totalCount > 5) {
      html += '<a href="https://www.feefo.com/en-GB/reviews/' + MERCHANT + '" target="_blank" rel="noopener" class="pdp-v2-reviews__view-all">View All Reviews</a>';
    }

    reviewsEl.innerHTML = html;
  }

  function buildStars(rating) {
    var s = '';
    var uid = _starUid++;
    for (var i = 1; i <= 5; i++) {
      if (rating >= i) {
        s += '<svg width="16" height="16" viewBox="0 0 16 16" fill="#000000" xmlns="http://www.w3.org/2000/svg"><path d="M8 0L10.12 5.26L16 5.87L11.64 9.74L12.94 15.51L8 12.49L3.06 15.51L4.36 9.74L0 5.87L5.88 5.26L8 0Z"/></svg>';
      } else if (rating >= i - 0.5) {
        var gid = 'pdp-half-' + uid + '-' + i;
        s += '<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">'
          + '<defs><linearGradient id="' + gid + '"><stop offset="50%" stop-color="#000000"/>'
          + '<stop offset="50%" stop-color="#D1D5DB"/></linearGradient></defs>'
          + '<path d="M8 0L10.12 5.26L16 5.87L11.64 9.74L12.94 15.51L8 12.49L3.06 15.51L4.36 9.74L0 5.87L5.88 5.26L8 0Z" fill="url(#' + gid + ')"/></svg>';
      } else {
        s += '<svg width="16" height="16" viewBox="0 0 16 16" fill="#D1D5DB" xmlns="http://www.w3.org/2000/svg"><path d="M8 0L10.12 5.26L16 5.87L11.64 9.74L12.94 15.51L8 12.49L3.06 15.51L4.36 9.74L0 5.87L5.88 5.26L8 0Z"/></svg>';
      }
    }
    return s;
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function esc(str) {
    _escEl.textContent = str || '';
    return _escEl.innerHTML;
  }
})();
